import Dataset from "datasets/types/interfaces/dataset";
import { useFetcher } from "~/hooks/useFetcher";
import useUserPermission from "~/hooks/useUserPermission";

const { VITE_CATALOG_API } = import.meta.env;

interface UseDatasetOptions {
  offset?: number;
  limit?: number;
  sortBy?: "title" | "createdAt" | "updatedAt";
  sortOrder?: "asc" | "desc";
}

const useDatasets = (options: UseDatasetOptions = {}) => {
  const canListDatasets = useUserPermission("list:catalog-dataset");
  // TODO: Adjust limit when pagination properly implemented
  const { offset = 0, limit = 1000, sortBy = "updatedAt", sortOrder = "desc" } = options;

  let url = `${VITE_CATALOG_API}/datasets?offset=${offset}&limit=${limit}`;

  if (sortBy) {
    url += `&sort_by=${sortBy}&sort_order=${sortOrder}`;
  }

  return useFetcher<Dataset[]>(canListDatasets ? url : null);
};

export default useDatasets;
